import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles({
  emptyContainer: {
    textAlign: 'center',
    padding: '25px',
  },
  emptyMessage: {
    color: '#999999',
    fontSize: '16px',
    marginTop: '26px',
  },
});

const NoContent = ({ message }) => {
  const classes = useStyles();

  return (
    <div className={classes.emptyContainer}>
      <p className={classes.emptyMessage}>{message}</p>
    </div>
  );
};

export default NoContent;
